<template>
    <!--    <div class="flex flex-nowrap gap-4 my-4">-->
    <!--        <div class="flex-grow" v-for="chunk of chunkedReviews">-->
    <!--            <ReviewCard v-for="review of chunk" :review="review"></ReviewCard>-->
    <!--        </div>-->
    <!--    </div>-->

    <carousel :settings="carouselSettings" class="mb-16 translate-x-0">
        <slide v-for="(chunk, index) of chunkedReviews" :key="index" class="flex-col p-3">
            <ReviewCard v-for="review of chunk"
                        :review="review"
                        max-comment-length="150"
                        class="text-left w-full"
                        slimline
            ></ReviewCard>
        </slide>
    </carousel>
</template>

<script setup>
import "vue3-carousel/dist/carousel.css";
import {computed} from "vue";
import {Carousel, Slide} from "vue3-carousel";
import ReviewCard from "@/Components/Reviews/ReviewCard";

const props = defineProps({
    reviews: Array
});

const chunkedReviews = computed(() => {
    const perChunk = 2;

    return props.reviews.reduce((carryArray, review, index) => {
        const chunkIndex = Math.floor(index / perChunk);

        if (!carryArray[chunkIndex]) {
            carryArray[chunkIndex] = [];
        }

        carryArray[chunkIndex].push(review);

        return carryArray;
    }, []);
});

const carouselSettings = {
    itemsToShow: 1,
    autoplay: 3000,
    transition: 3000,
    mouseDrag: false,
    touchDrag: false,
    wrapAround: true,
    pauseAutoplayOnHover: true,
    breakpoints: {
        768: {
            itemsToShow: 2,
            snapAlign: "start"
        },
        1200: {
            itemsToShow: 3,
            snapAlign: "start"
        },
        1600: {
            itemsToShow: 4,
            snapAlign: "start"
        }
    }
};
</script>

<style scoped>

</style>
